/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Sources_Document_FailedInputs */



/**
* | output |
* | --- |
* | "could not be read" |
*
* @param {Meeting_Sources_Document_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_sources_document_failed = /** @type {((inputs?: Meeting_Sources_Document_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Sources_Document_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("kon niet gelezen worden")
	if (locale === "fr") return /** @type {LocalizedString} */ ("n'a pas pu être lu")
	return /** @type {LocalizedString} */ ("could not be read")
});